import { SelectItemVm } from '@treasury/presentation/components/forms';

export type StopPaymentStatus =
    | 'PendingApproval'
    | 'ApprovalRejected'
    | 'Cancelled'
    | 'Active'
    | 'Expired';

const stopPaymentStatusLabels: Record<StopPaymentStatus, string> = {
    PendingApproval: 'Pending Approval',
    ApprovalRejected: 'Approval Rejected',
    Cancelled: 'Cancelled',
    Active: 'Active',
    Expired: 'Expired',
};

export function mapStopPaymentStatusToVm(
    status: StopPaymentStatus
): SelectItemVm<StopPaymentStatus> {
    if (!(status in stopPaymentStatusLabels)) {
        throw new Error(`Unknown stop payment status: ${status}`);
    }

    return {
        label: stopPaymentStatusLabels[status],
        value: status,
    };
}

export const stopPaymentStatuses: StopPaymentStatus[] = [
    'PendingApproval',
    'ApprovalRejected',
    'Cancelled',
    'Active',
    'Expired',
];
